import { API } from "@/lib/api";
import { Phone, Hash } from "lucide-react";

/**
 * Live mock of the PDF "Prepared by" header so contractors can see exactly how
 * their logo + details will appear on the report before downloading.
 */
export const PdfBrandingPreview = ({ form, hasLogo, logoVersion, userName }) => {
  const company = (form.company_name || "").trim();
  const phone = (form.company_phone || "").trim();
  const license = (form.license_number || "").trim();
  const empty = !company && !phone && !license && !hasLogo;

  return (
    <div className="mt-5" data-testid="pdf-branding-preview">
      <p className="text-[12px] font-bold uppercase tracking-wide text-mortar mb-2">Report preview</p>
      <div className="rounded-input border border-gravel bg-white shadow-sm overflow-hidden select-none">
        {/* PDF header bar */}
        <div className="bg-navy px-4 py-2.5 flex items-center justify-between">
          <span className="font-extrabold text-white text-[13px] tracking-tight">
            Measure<span className="text-[#E07B2A]">The</span>Roof
          </span>
          <span className="text-[#9FB0BD] text-[9px] uppercase tracking-[0.15em]">Aerial Measurement Report</span>
        </div>

        <div className="p-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-mortar mb-2">Prepared by</p>
          {empty ? (
            <p className="text-[12px] text-mortar italic">
              Add your company name, phone, license, or logo above to see them on the report.
            </p>
          ) : (
            <div className="flex items-start gap-3">
              {hasLogo && (
                <div className="w-[80px] h-[44px] rounded border border-gravel bg-fieldstone grid place-items-center overflow-hidden shrink-0">
                  <img
                    src={`${API}/account/logo?v=${logoVersion}`}
                    alt="Company logo"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              )}
              <div className="min-w-0">
                <p className="font-bold text-navy text-[15px] leading-tight truncate">
                  {company || userName || "Your Company"}
                </p>
                <div className="mt-1 space-y-0.5">
                  {phone && (
                    <p className="text-[12px] text-mortar flex items-center gap-1.5">
                      <Phone size={12} /> {phone}
                    </p>
                  )}
                  {license && (
                    <p className="text-[12px] text-mortar flex items-center gap-1.5">
                      <Hash size={12} /> License #: {license}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* faux measurement strip to convey it's a report */}
          <div className="mt-4 grid grid-cols-3 gap-2">
            {[
              ["Total area", "—— sq ft"],
              ["Squares", "——"],
              ["Pitch", "—/12"],
            ].map(([label, val]) => (
              <div key={label} className="rounded bg-fieldstone px-2 py-1.5">
                <p className="text-[8px] uppercase tracking-wide text-mortar">{label}</p>
                <p className="text-[13px] font-extrabold text-navy">{val}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="text-[11px] text-mortar mt-2">This is a live preview. Actual reports include your satellite image, roof diagram and full measurements.</p>
    </div>
  );
};
